export default {
  plural: "Benutzer",
  columns: {
    userName: "Benutzer",
    status: "Status",
    approved: "Genehmigt",
    withoutEAApproval: "Ohne EA",
    pending: "Ausstehend",
    pendingInvite: "Einladung ausstehend",
    declined: "Abgelehnt",
    firstName: "Vorname",
    lastName: "Nachname",
    contact: "Kontakt",
    email: "Email",
    emailAdress: "E-Mail Adresse",
    tenant: "Organisation",
    role: "Rolle",
    roles: "Rollen",
    registered: "Registriert",
    displayName: "Anzeigename",
    createdAt: "Erstellt am",
    createdBy: "Erstellt von",
    expirationAt: "Ablaufdatum",
  },
};
